import script from "./ReadingStreakIcon16464.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReadingStreakIcon16464.vue?vue&type=script&setup=true&lang=ts"

import "./ReadingStreakIcon16464.vue?vue&type=style&index=0&id=5d2980c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d2980c0"]])

export default __exports__